import { Controller } from 'stimulus';

// Editor for account-level table template columns (Settings > Reports).
// Maintains an ordered, drag-sortable list of columns; each is either
// automatic (value pulled from job data) or manual (header only).
// Serializes the list to a hidden JSON field on submit.
export default class extends Controller {
  static targets = ['list', 'item', 'autoSelect', 'manualInput', 'dataInput'];

  connect() {
    $(this.listTarget).sortable({
      axis: 'y',
      handle: '[data-role="drag-handle"]',
      tolerance: 'pointer',
      items: '> [data-target="table-template-columns.item"]',
      cursor: 'move',
    });
  }

  addAuto(event) {
    event.preventDefault();
    const select = this.autoSelectTarget;
    const key = select.value;
    if (!key) return;

    const label = select.options[select.selectedIndex].text;
    this.listTarget.insertAdjacentHTML('beforeend', this.autoItemHTML(key, label));
  }

  addManual(event) {
    event.preventDefault();
    const label = this.manualInputTarget.value.trim();
    if (!label) return;

    this.listTarget.insertAdjacentHTML('beforeend', this.manualItemHTML(label));
    this.manualInputTarget.value = '';
  }

  removeItem(event) {
    event.preventDefault();
    event.target.closest('[data-target="table-template-columns.item"]').remove();
  }

  serialize() {
    const columns = this.itemTargets.map((item) => {
      if (item.dataset.kind === 'auto') {
        return { kind: 'auto', key: item.dataset.key };
      }
      const input = item.querySelector('input');
      return { kind: 'manual', label: input ? input.value.trim() : '' };
    });

    this.dataInputTarget.value = JSON.stringify(columns);
  }

  autoItemHTML(key, label) {
    return `
      <li class="flex items-center border border-gray-200 rounded px-3 py-2 mb-2 bg-white"
          data-target="table-template-columns.item" data-kind="auto" data-key="${this.escape(key)}">
        <span data-role="drag-handle" class="cursor-move text-gray-400 mr-3" title="Drag to reorder">&#8942;&#8942;</span>
        <span class="text-sm text-gray-700 flex-1">${this.escape(label)}</span>
        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mr-3">Automatic</span>
        <button type="button" class="text-sm text-red-600 hover:text-red-800 focus:outline-none"
                data-action="table-template-columns#removeItem">Remove</button>
      </li>`;
  }

  manualItemHTML(label) {
    return `
      <li class="flex items-center border border-gray-200 rounded px-3 py-2 mb-2 bg-white"
          data-target="table-template-columns.item" data-kind="manual">
        <span data-role="drag-handle" class="cursor-move text-gray-400 mr-3" title="Drag to reorder">&#8942;&#8942;</span>
        <input type="text" value="${this.escape(label)}" class="form-input text-sm flex-1 mr-3" placeholder="Column header">
        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 mr-3">Manual</span>
        <button type="button" class="text-sm text-red-600 hover:text-red-800 focus:outline-none"
                data-action="table-template-columns#removeItem">Remove</button>
      </li>`;
  }

  escape(value) {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML.replace(/"/g, '&quot;');
  }
}
